import React from 'react'

export default function Contact() {
  return (
    <div className="bg-gradient-to-b from-sky-50 to-white min-h-screen pt-28 pb-20 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-3xl shadow-[0_25px_70px_-35px_rgba(15,23,42,0.35)] border border-slate-100 p-8 sm:p-10">
          <h1 className="text-center text-3xl sm:text-4xl font-extrabold text-slate-900 mb-8">
            تواصل معنا
          </h1>

          <div className="space-y-6 text-center text-lg sm:text-xl text-slate-800 leading-relaxed">
            <div className="space-y-2">
              <p className="font-bold text-sky-700">للاستفسارات:</p>
              <a
                href="mailto:tamkeenx@ksu.edu.sa"
                className="inline-flex items-center justify-center rounded-full bg-sky-50 px-4 py-2 text-sky-800 font-semibold border border-sky-100 hover:bg-sky-100 transition"
              >
                tamkeenx@ksu.edu.sa
              </a>
            </div>

            <div className="space-y-2">
              <p className="font-bold text-sky-700">للدعم الفني والتقني:</p>
              <a
                href="mailto:dsdet@ksu.edu.sa"
                className="inline-flex items-center justify-center rounded-full bg-emerald-50 px-4 py-2 text-emerald-800 font-semibold border border-emerald-100 hover:bg-emerald-100 transition"
              >
                dsdet@ksu.edu.sa
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
